var styleDataHash = 'd9814023';  
export const injectCss = (() => {
  var css = `.tqk0W{box-sizing:border-box;color:#fff;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,Helvetica,Arial,sans-serif!important;font-size:14px;letter-spacing:0;line-height:20px;max-width:690px;position:fixed;width:fit-content;z-index:100002;-webkit-font-smoothing:antialiased;opacity:1;overflow-wrap:break-word;top:35px;word-break:break-word}[dir] .tqk0W{border-radius:2px;box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1))}[dir=ltr] .tqk0W{left:50%;padding:16px 68px 16px 29px;transform:translate(-50%)}[dir=rtl] .tqk0W{padding:16px 29px 16px 68px;right:50%;transform:translate(50%)}.tqk0W a{color:#fff;text-decoration:underline}[dir] .tqk0W a{cursor:pointer}.zEaiC{box-sizing:content-box;height:12px;opacity:1;position:absolute;top:40%;width:12px;z-index:100003;z-index:6001;fill:#fff}[dir] .zEaiC{border:hidden;border-radius:4px;cursor:pointer}[dir=ltr] .zEaiC{right:19px}[dir=rtl] .zEaiC{left:19px}.-c9-k{bottom:0;height:fit-content;position:fixed;width:100%}[dir] .-c9-k{margin-top:auto}[dir] .wcTet{background-color:#df3131}[dir] .b2I-q{background-color:#008250}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "toastContainer": "tqk0W",
  "close": "zEaiC",
  "mobile": "-c9-k",
  "error": "wcTet",
  "success": "b2I-q"
};